import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { userState } from "../recoil/atom";
import { endpoint } from "../utils/api";

function useLoad() {
  const setUser = useSetRecoilState(userState);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const rawToken = localStorage.getItem("token");
    const token = rawToken && rawToken !== "undefined" && rawToken !== "null"
      ? rawToken
      : null;

    // 🔒 1) 토큰이 없거나 이상한 값이면 -> 강제 로그아웃 & 로그인 페이지로
    if (!token) {
      localStorage.removeItem("token");
      localStorage.removeItem("logoutTime");
      localStorage.removeItem("user_id");
      localStorage.removeItem("user_position");
      localStorage.removeItem("user_name");
      localStorage.removeItem("user_level");
      localStorage.removeItem("branch");
      localStorage.removeItem("permissions");
      localStorage.removeItem("is_use_head");
      setUser(null);

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
      return;
    }

    // 🔍 2) 정상 토큰이 있을 때만 info 호출
    fetch(`${endpoint}/manager/setting/info`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    }).then(async (response) => {
      // 2-1) 토큰이 만료되었거나 유효하지 않으면 401 예상
      if (response.status === 401 || response.status === 403) {
        // 세션 만료 처리
        localStorage.removeItem("token");
        localStorage.removeItem("logoutTime");
        localStorage.removeItem("user_id");
        localStorage.removeItem("user_position");
        localStorage.removeItem("user_name");
        localStorage.removeItem("user_level");
        localStorage.removeItem("branch");
        localStorage.removeItem("permissions");
        localStorage.removeItem("is_use_head");
        setUser(null);

        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return;
      }

      if (!response.ok) {
        // 그 외 에러는 콘솔에만 남기고, 일단 유저 정보는 날리지 않음
        console.error("manager/setting/info request failed", response.status);
        return;
      }

      const body = await response.json();
      const data = body?.data;

      if (!data?.user_info) {
        // 형식이 예상과 다를 때 방어
        console.warn("Invalid user_info in manager/setting/info response", body);
        return;
      }

      const user = data.user_info;

      localStorage.setItem("user_id", user.id);
      localStorage.setItem("user_position", user.position);
      localStorage.setItem("user_name", user.name);
      localStorage.setItem("user_level", user.level);
      // Phase 6c: legacy `branch` localStorage 저장 제거 — 모든 권한 분기는 permissions 사용
      localStorage.setItem(
        "permissions",
        JSON.stringify(user.permissions || {})
      );
      localStorage.setItem("is_use_head", user.is_use_head);

      setUser(user);
    })
    .catch((err) => {
      console.error("manager/setting/info request error", err);
    });
      
    // fetch(`${endpoint}/manager/setting/info`, {
    //   headers: {
    //     Authorization: "Bearer " + token,
    //   },
    // })
    //   .then((response) => response.json())
    //   .then((response) => {
    //     if (response.code || !response.data) throw new Error(response.message);
    //     localStorage.setItem("user_id", response.data?.user_info?.id);
    //     localStorage.setItem(
    //       "user_position",
    //       response.data?.user_info?.position
    //     );
    //     localStorage.setItem("user_name", response.data?.user_info?.name);
    //     localStorage.setItem("user_level", response.data?.user_info?.level);
    //     localStorage.setItem("branch", response.data?.user_info?.branch);
    //     setUser(response.data?.user_info || null);
    //   })
    //   .catch((e) => {
    //     localStorage.clear();
    //     if (window.location.pathname === "/login") return;
    //     window.location.href = "/login";
    //   });
  }, [setUser]);
}

export default useLoad;
